<script setup lang="ts">
import {Icon} from "@iconify/vue";
import {Dialog} from "@/Components/Library";
import {register} from "swiper/element/bundle";
import {useTemplateRef} from "vue";

const model = defineModel({default: true});
register();
const swiperEl = useTemplateRef("swiperEl");

const prevSlide = () => {
    swiperEl.value.swiper.slidePrev();
};

const nextSlide = () => {
    swiperEl.value.swiper.slideNext();
};
</script>
<template>
    <Dialog v-model:visible="model" modal header="Hi there!" class="mx-2 max-h-dvh w-full max-w-lg overflow-y-auto">
        <div class="relative pb-16">
            <swiper-container
                :slides-per-view="1"
                :navigation="{
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                }"
                :pagination="true"
                :loop="true"
                pagination
                ref="swiperEl"
            >
                <swiper-slide>
                    <div class="-flex items-center">
                        <h1 class="mb-2 text-xl font-bold">Welcome to ASKr</h1>
                        <p class="mb-3 text-sm lg:text-base">
                            ASKr is the best way to ask questions to groups of people. Think of a question and how you
                            want to ask it, add any stimulus materials, choose some people to launch it to and launch.
                            It’s that easy.
                        </p>
                        <img src="/images/onboarding/feed.png" alt="ASKr feed" class="w-full" />
                    </div>
                </swiper-slide>
                <swiper-slide>
                    <div class="-flex items-center">
                        <h1 class="mb-2 text-xl font-bold">This is your feed</h1>
                        <p class="mb-3 text-sm lg:text-base">
                            All the questions you are asked to response will appear here.
                        </p>
                        <img src="/images/onboarding/feed.png" alt="ASKr feed" class="w-full" />
                    </div>
                </swiper-slide>
                <swiper-slide>
                    <div class="-flex items-center">
                        <h1 class="mb-2 text-xl font-bold">These are your Contacts</h1>
                        <p class="mb-3 text-sm lg:text-base">
                            If you’ve asked someone a question or if they’ve asked you a question, you’ll be connected
                            in ASKr. All your ASKr contacts are listed here.
                        </p>
                        <img src="/images/onboarding/contacts.png" alt="ASKr feed" class="w-full" />
                    </div>
                </swiper-slide>
                <swiper-slide>
                    <div class="-flex items-center">
                        <h1 class="mb-2 text-xl font-bold">These are your Groups</h1>
                        <p class="mb-3 text-sm lg:text-base">
                            ASKr is designed to make it easy to work in groups, asking each other questions. Manage your
                            groups here.
                        </p>
                        <img src="/images/onboarding/groups.png" alt="ASKr feed" class="w-full" />
                    </div>
                </swiper-slide>
                <swiper-slide>
                    <div class="-flex items-center">
                        <h1 class="mb-2 text-xl font-bold">These are your Stimuli</h1>
                        <p class="mb-3 text-sm lg:text-base">
                            Sometimes you want ask questions about specific things like a document, a video or perhaps a
                            website. In ASKr these are called stimuli, and you’ll find all of yours here.
                        </p>
                        <img src="/images/onboarding/stimuli.png" alt="ASKr feed" class="w-full" />
                    </div>
                </swiper-slide>
                <swiper-slide>
                    <div class="-flex items-center">
                        <h1 class="mb-2 text-xl font-bold">These are your Questions</h1>
                        <p class="mb-3 text-sm lg:text-base">
                            Some questions you’ll want to ask again and again to different groups of people. ASKr keeps
                            all your previous questions so you can edit and reuse them whenever you want to.
                        </p>
                        <img src="/images/onboarding/questions.png" alt="ASKr feed" class="w-full" />
                    </div>
                </swiper-slide>
                <swiper-slide>
                    <div class="-flex items-center">
                        <h1 class="mb-2 text-xl font-bold">These are your Responses</h1>
                        <p class="mb-3 text-sm lg:text-base">
                            Questions with their responses can be found here. Responses can be filtered by individual
                            groups or in aggregate as you choose.
                        </p>
                        <img src="/images/onboarding/responses.png" alt="ASKr feed" class="w-full" />
                    </div>
                </swiper-slide>
            </swiper-container>
            <button
                @click="prevSlide"
                class="swiper-button-prev-custom absolute bottom-3 left-1 z-10 rounded-full bg-white/90 text-askr-green shadow transition disabled:opacity-20"
            >
                <Icon icon="material-symbols:chevron-left-rounded" class="text-[1.675rem] lg:text-[2rem]" />
            </button>
            <button
                @click="nextSlide"
                class="swiper-button-next-custom absolute bottom-3 right-1 z-10 rounded-full bg-white/90 text-askr-green shadow transition disabled:opacity-20"
            >
                <Icon icon="material-symbols:chevron-right-rounded" class="text-[1.675rem] lg:text-[2rem]" />
            </button>
        </div>
    </Dialog>
</template>
<style scoped></style>
